import { Phone, MapPin, Navigation } from "lucide-react";
import { WhatsAppIcon, InstagramIcon } from "./Icons";
import { SectionTitle } from "./SectionTitle";
import { LunessaMap } from "./LunessaMap";
import { GoogleRating } from "./GoogleRating";
import { TEL, WA, IG, IG_HANDLE, PHONE_DISPLAY, ADDRESS, MAPS_DIR } from "../../lib/site";

const Row = ({ icon: Icon, label, value, href, testId, external }) => (
  <a
    href={href}
    data-testid={testId}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="group flex items-center gap-4 rounded-2xl border border-gold/20 bg-white p-4 transition-[border-color,box-shadow] duration-300 hover:border-gold/50 hover:shadow-[0_14px_30px_-18px_rgba(4,78,59,0.3)]"
  >
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-950 text-gold-light transition-colors group-hover:bg-emerald-800">
      <Icon className="h-[18px] w-[18px]" strokeWidth={1.8} />
    </span>
    <span className="min-w-0">
      <span className="block text-xs uppercase tracking-[0.18em] text-ink/50">{label}</span>
      <span className="block break-words text-[15px] font-medium text-emerald-950">{value}</span>
    </span>
  </a>
);

export const ContactBlock = () => (
  <div className="grid gap-8 lg:grid-cols-[1fr_1.2fr] lg:gap-12">
    <div className="space-y-3">
      <Row icon={Phone} label="Telefon" value={PHONE_DISPLAY} href={TEL} testId="contact-phone" />
      <Row icon={WhatsAppIcon} label="WhatsApp" value="WhatsApp’tan Randevu Al" href={WA} testId="contact-whatsapp" external />
      <Row icon={InstagramIcon} label="Instagram" value={IG_HANDLE} href={IG} testId="contact-instagram" external />
      <Row icon={MapPin} label="Adres" value={ADDRESS} href={MAPS_DIR} testId="contact-address" external />
      <a href={MAPS_DIR} target="_blank" rel="noopener noreferrer" className="btn-gold mt-3 w-full sm:w-auto" data-testid="contact-directions-btn">
        <Navigation className="h-4 w-4" /> Yol Tarifi Al
      </a>
      <div className="pt-2">
        <GoogleRating compact testId="contact-google-rating" />
      </div>
    </div>
    <div className="overflow-hidden rounded-3xl border border-gold/25 shadow-[0_20px_40px_-24px_rgba(4,78,59,0.35)]">
      <LunessaMap />
    </div>
  </div>
);

export const ContactSection = () => (
  <section id="iletisim" className="container-lux py-20 lg:py-28" data-testid="contact-section">
    <SectionTitle eyebrow="İletişim" title="Lunessa Spa Masaj İletişim" sub="Randevu ve bilgi için bize telefonla ya da WhatsApp üzerinden ulaşabilirsiniz." />
    <ContactBlock />
  </section>
);
